import {Outlet} from "react-router-dom";

const Members = () => {

    return (
        <Outlet />
    )
}

export default Members